import { createAsyncThunk } from "@reduxjs/toolkit"
import { Api, ApiMethod } from "../../../../utils/Api"
import axios from "axios"
// import { ChatLog } from "./interface"

const endpoint = process.env.REACT_APP_CHATBOT_API_URL

export const candidateInterviewBot = createAsyncThunk('candidate-interviewBot/chat',
  async (interviewId: string, { rejectWithValue }) => 
    Api(ApiMethod.GET, endpoint, `candidate/interview`, {interviewId}, rejectWithValue)
)

//{ jobId, companyCode }: { jobId: number, companyCode: string }
export const candidateUploadS3 = createAsyncThunk('candidate-interviewBot/uploadS3',
  async ({media, contentType, uploadUrl}: { media: ArrayBuffer, contentType: string, uploadUrl: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.request({ 
        url: uploadUrl,
        method: ApiMethod.PUT, 
        headers: {'content-type': contentType},
        data: media
      });
      return data;
    } catch(error) {
      return rejectWithValue(error);
    }
  }
)
